// extracted by mini-css-extract-plugin
module.exports = {"container":"BuyerAddressForm_container__2ER2K"};